import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginAdmin } from '../services/firebase';
import { Input, Button, Spinner } from '../components/ui';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginAdmin(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(mapFirebaseError(err.code));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--navy)',
      backgroundImage: 'radial-gradient(ellipse at 70% 20%, rgba(31,147,224,0.08) 0%, transparent 60%)',
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '0 20px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <LogoSvg />
          <div style={{ fontFamily: 'var(--font-serif)', fontSize: '24px', marginTop: '12px' }}>
            Just Salento
          </div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: '4px' }}>
            Pannello Gestione Lido
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'var(--navy-mid)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)', padding: '28px 28px',
        }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Input
              label="Email"
              type="email"
              placeholder="info@tuolido.it"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
            <Input
              label="Password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />

            {error && (
              <div style={{
                background: 'rgba(231,76,60,0.1)', border: '1px solid rgba(231,76,60,0.3)',
                borderRadius: 'var(--radius-md)', padding: '10px 12px',
                fontSize: '12.5px', color: '#f87171',
              }}>
                {error}
              </div>
            )}

            <Button type="submit" variant="primary" fullWidth disabled={loading} size="lg"
              style={{ marginTop: '4px' }}>
              {loading ? <Spinner size={16} /> : 'Accedi'}
            </Button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '13px', color: 'var(--text-muted)' }}>
            Non hai un account?{' '}
            <Link to="/register" style={{ color: 'var(--ocean)', textDecoration: 'none' }}>
              Registra il tuo lido
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function LogoSvg() {
  return (
    <svg width="52" height="52" viewBox="0 0 36 36" fill="none" style={{ margin: '0 auto', display: 'block' }}>
      <circle cx="18" cy="18" r="18" fill="#2A6E7F" />
      <ellipse cx="18" cy="26" rx="10" ry="4" fill="#F5C842" opacity="0.9" />
      <path d="M12 22 Q18 14 24 22" stroke="#1f93e0" strokeWidth="1.5" fill="rgba(31,147,224,0.3)" />
      <line x1="18" y1="22" x2="18" y2="28" stroke="#c4a060" strokeWidth="1.5" />
      <path d="M12 17 Q18 11 24 17" stroke="white" strokeWidth="1.2" fill="rgba(255,255,255,0.25)" />
      <circle cx="24" cy="12" r="4" fill="#F5C842" opacity="0.9" />
    </svg>
  );
}

function mapFirebaseError(code) {
  const map = {
    'auth/user-not-found':    'Nessun account trovato con questa email.',
    'auth/wrong-password':    'Password errata. Riprova.',
    'auth/invalid-email':     'Indirizzo email non valido.',
    'auth/too-many-requests': 'Troppi tentativi. Riprova tra qualche minuto.',
    'auth/invalid-credential':'Email o password errati.',
  };
  return map[code] || 'Errore di accesso. Riprova.';
}
